import React, { useState } from "react";
import { FaImage } from "react-icons/fa";
import { useDispatch } from "react-redux";

import { createDepartment } from "../../redux/services/DepartmentService/deparment.Services";
import { successToast, errorToast } from "../../Utils/toast";
import { closeModal } from "../../redux/features/modalSlice";
import { useSelector } from "react-redux";
function AddDepartemt() {
  const dispatch = useDispatch();
  const { refreshData } = useSelector((state) => state.modal);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    status: true,

  });

  const [preview, setPreview] = useState(null);

  // INPUT CHANGE
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "status" ? value === "Active" : value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = ["Department Name is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };

  // SUBMIT (MODAL SAFE)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField =
          document.querySelector(".is-invalid");

        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);

      return;
    }
    try {
      setIsLoading(true);

      const res = await createDepartment({
        name: formData.name,
        status: formData.status,
      });
      successToast(res?.message);
      if (refreshData) {
        refreshData();
      }
      // reset
      setFormData({
        name: "",
        status: true,
        icon: null,
      });
      dispatch(closeModal());
    } catch (err) {
      console.log(err);
      errorToast("Error creating role ❌");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <div className="modal-form-wrapper">
      <form onSubmit={handleSubmit} className="row">
        <div className="col-md-12">
          <label>Department Name<span className="text-danger">*</span></label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className={`form-control ${errors?.name ? "is-invalid" : ""
              }`}
            placeholder="Enter Department name"
          />
          {errors?.name && (
            <div className="invalid-feedback d-block">
              {errors.name[0]}
            </div>
          )}
        </div>

        {/* STATUS */}
        <div className="col-md-12">
          <label>Status</label>
          <select
            name="status"
            value={formData.status ? "Active" : "Inactive"}
            onChange={handleChange}
            className="form-control"
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>


        {/* BUTTON */}
        <div className="col-md-12 text-end">
          <button
            type="submit"
            disabled={isLoading}
            className="add-btn"
          >
            {isLoading ? "Saving..." : "Save Role"}
          </button>
        </div>

      </form>

    </div>
  );
}

export default AddDepartemt;